import { useEffect, useRef, useState } from "react";
import { Eraser, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

export const SignaturePad = ({ value, onChange, label = "Firma qui" }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    const c = ref.current;
    const ctx = c.getContext("2d");
    ctx.clearRect(0, 0, c.width, c.height);
    if (value) { const img = new Image(); img.onload = () => ctx.drawImage(img, 0, 0, c.width, c.height); img.src = value; }
  }, [value]);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return [(p.clientX - r.left) * (ref.current.width / r.width), (p.clientY - r.top) * (ref.current.height / r.height)];
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = ref.current.getContext("2d");
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.strokeStyle = "#0D3B52";
    ctx.lineTo(...pos(e)); ctx.stroke(); setDirty(true);
  };
  const end = () => { drawing.current = false; };
  const clear = () => { ref.current.getContext("2d").clearRect(0, 0, ref.current.width, ref.current.height); setDirty(false); onChange(""); };
  const confirm = () => { onChange(ref.current.toDataURL("image/png")); setDirty(false); };

  return (
    <div className="space-y-2" data-testid="signature-pad">
      <canvas ref={ref} width={600} height={200}
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        className="w-full h-40 rounded-lg border-2 border-dashed border-[#D4AF37] bg-white touch-none cursor-crosshair" data-testid="signature-canvas" />
      <div className="flex items-center justify-between">
        <p className="text-xs text-[#5C6B73]">{value && !dirty ? "Firma acquisita" : label}</p>
        <div className="flex gap-2">
          <Button type="button" size="sm" variant="outline" onClick={clear} data-testid="signature-clear"><Eraser className="h-4 w-4 mr-1" />Cancella</Button>
          <Button type="button" size="sm" onClick={confirm} disabled={!dirty} data-testid="signature-confirm" className="bg-[#0D3B52] hover:bg-[#082535]"><Check className="h-4 w-4 mr-1" />Conferma firma</Button>
        </div>
      </div>
    </div>
  );
};
